import {patchState, signalStore, withMethods, withState} from '@ngrx/signals';

const initialState = {
  childComponentVisible: true
};

export const MainViewStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store) => ({
    showChildComponent() {
      patchState(store, {childComponentVisible: true});
    },
    hideChildComponent() {
      patchState(store, {childComponentVisible: false});
    }
  })
));
